export default "__VITE_ASSET__6AWvlY4o__"